import { BaseMeiucaService } from './MeiucaService'
import { env, apiEndpoints } from '@/lib/env'

interface RequestPasswordResetRequest {
  phoneNumber: string
}

interface RequestPasswordResetResponse {
  message?: string
}

interface ConfirmPasswordResetRequest {
  token: string
  newPassword: string
}

interface ConfirmPasswordResetResponse {
  message?: string
}

class PasswordService extends BaseMeiucaService {
  constructor() {
    super({
      baseURL: env.API_URL,
      refreshEndpoint: apiEndpoints.auth.refresh,
      cookiePrefix: '',
      debug: env.IS_DEVELOPMENT,
      onAuthenticationError: () => {
        if (typeof window !== 'undefined') {
          window.location.replace('/')
        }
      }
    })
  }

  async requestPasswordReset(phoneNumber: string): Promise<RequestPasswordResetResponse> {
    const request: RequestPasswordResetRequest = { phoneNumber: `+55${phoneNumber}` }
    const response = await this.post<RequestPasswordResetResponse>(
      '/auth/request-password-reset',
      request
    )
    return response.data.data ?? response.data
  }

  async confirmPasswordReset(token: string, newPassword: string): Promise<ConfirmPasswordResetResponse> {
    const request: ConfirmPasswordResetRequest = {
      token,
      newPassword
    }
    const response = await this.post<ConfirmPasswordResetResponse>(
      '/auth/confirm-password-reset',
      request
    )
    return response.data.data ?? response.data
  }
}

export const passwordService = new PasswordService()
